<template>
  <v-responsive
    min-width="180"
    :max-width="maxWidth"
    :max-height="maxWidth"
    min-height="180"
    :aspect-ratio="1 / 1"
  >
    <div class="eclipse wrapper">
      <div class="eclipse thin"></div>
      <img :src="logo" class="logo" />
      <div class="eclipse thick"></div>
      <div class="eclipse yello" />
    </div>
  </v-responsive>
</template>
<script>
export default {
  props: {
    maxWidth: {
      type: String,
      default: "300px",
    },
  },
  data: () => ({
    logo: require("../../assets/images/bplogo.svg"),
  }),
};
</script>
<style lang="scss">
.eclipse {
  border-radius: 50%;
  border-style: solid;
}
.wrapper {
  position: relative;
  border-width: 0px;
  width: 100%;
  height: 100%;
}
.logo {
  width: 75%;
  height: 75%;
  position: absolute;
  left: 12.5%;
  top: 12.5%;
}

.thin {
  width: 100%;
  height: 100%;
  opacity: 0.5;
  border-width: 1px;
  position: absolute;
  border-color: #232342;
}
.thick {
  top: 3%;
  left: 3%;
  width: 94%;
  height: 94%;
  border-width: 8px;
  position: absolute;
  border-color: #e2e2e2;
}
.yello {
  top: 3%;
  left: 3%;
  width: 94%;
  height: 94%;
  border-width: 8px;
  position: absolute;
  transform: rotate(-45deg);
  border-color: #0bb351 transparent;
  animation: ellipseRotate 15s ease-in-out infinite;
}
@keyframes ellipseRotate {
  0% {
    transform: rotate(-45deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
</style>
